/**
 * Pick the correct filename extension for a given audio MIME type.
 * Critical for cross-browser playback — iOS Safari records as audio/mp4,
 * Chrome/Firefox as audio/webm. If we mislabel the file the <audio> element
 * silently refuses to play it back.
 */
export function audioExtFromMime(mime) {
  const m = (mime || "").toLowerCase();
  if (m.includes("webm")) return "webm";
  if (m.includes("ogg")) return "ogg";
  if (m.includes("mp4") || m.includes("m4a") || m.includes("aac")) return "m4a";
  if (m.includes("mpeg") || m.includes("mp3")) return "mp3";
  if (m.includes("wav")) return "wav";
  return "webm"; // sensible default
}

export function fileFromAudioBlob(blob, prefix = "clip") {
  const mime = blob.type || "audio/webm";
  const ext = audioExtFromMime(mime);
  return new File([blob], `${prefix}-${Date.now()}.${ext}`, { type: mime });
}
